window.NH_STORES = [
  {
    "id": 1,
    "name": "Nicohub Silom",
    "type": "Flagship",
    "slug": "nicohub-silom-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "87 Thanon Naradhiwat Rajanagarindra, Si Lom, Khet Bang Rak, Krung Thep Maha Nakhon 10500, Thailand",
    "phone": "063 431 0277",
    "website": "",
    "hours24": true,
    "lat": 13.7243754,
    "lng": 100.5293419
  },
  {
    "id": 2,
    "name": "Nicohub Sukhumvit Soi 31",
    "type": "Flagship",
    "slug": "snus-sukhumvit-soi-31-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "571 Sukhumvit 31, Khlong Tan Nuea, Watthana, Bangkok 10110",
    "phone": "063 082 8420",
    "website": "",
    "hours24": false,
    "lat": 13.7330331162723,
    "lng": 100.566532492357
  },
  {
    "id": 3,
    "name": "All Time High",
    "type": "Stockist",
    "slug": "all-time-high-nana-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "20 Soi Sukhumvit 3, Nua, Watthana, Krung Thep Maha Nakhon 10110, Thailand",
    "phone": "081 115 0157",
    "website": "",
    "hours24": true,
    "lat": 13.7454299,
    "lng": 100.5550155
  },
  {
    "id": 4,
    "name": "B Good 21 Lat Phrao",
    "type": "Stockist",
    "slug": "b-good-21-lat-phrao-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "24, 180 Lat Phrao 21 Alley, Lane 4, Chom Phon, Chatuchak, Bangkok 10900, Thailand",
    "phone": "083 851 4545",
    "website": "",
    "hours24": true,
    "lat": 13.8065706130887,
    "lng": 100.5732704
  },
  {
    "id": 5,
    "name": "B Good 37 Phrom Phong",
    "type": "Stockist",
    "slug": "b-good-sukhumvit-soi-37-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "1/10 Sukhumvit Soi 37, Khlong Tan Nuea, Bangkok 10110, Thailand",
    "phone": "096 147 4522",
    "website": "",
    "hours24": true,
    "lat": 13.730877657165,
    "lng": 100.570455437329
  },
  {
    "id": 6,
    "name": "B Good 56 On Nut",
    "type": "Stockist",
    "slug": "b-good-sukhumvit-soi-56-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "House no, 48/1 Soi Sukhumvit 56, Phra Khanong Tai, Phra Khanong, Bangkok 10260, Thailand",
    "phone": "096 649 6586",
    "website": "",
    "hours24": false,
    "lat": 13.7009620443312,
    "lng": 100.598135457513
  },
  {
    "id": 7,
    "name": "Broccoli",
    "type": "Stockist",
    "slug": "broccoli-bang-kapi-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "2802 Khwaeng Bang Kapi, Khet Huai Khwang, Krung Thep Maha Nakhon 10310, Thailand",
    "phone": "094 830 0731",
    "website": "",
    "hours24": true,
    "lat": 13.744285,
    "lng": 100.5857998
  },
  {
    "id": 8,
    "name": "CaliFire Kathu Phuket",
    "type": "Stockist",
    "slug": "califire-kathu-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "16 205 Phrabaramee Rd, Kathu, Kathu District, Phuket 83120, Thailand",
    "phone": "+66 80 741 4724",
    "website": "",
    "hours24": false,
    "lat": 7.91340711452207,
    "lng": 98.3415065219163
  },
  {
    "id": 9,
    "name": "California's Finest Khaosan",
    "type": "Stockist",
    "slug": "californias-finest-khaosan-road-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "53 Phra Sumen Rd, Ban Phan Thom, Phra Nakhon, Bangkok 10200, Thailand",
    "phone": "095 440 7410",
    "website": "",
    "hours24": true,
    "lat": 13.7619730577234,
    "lng": 100.501544206755
  },
  {
    "id": 10,
    "name": "California's Finest Soi 24",
    "type": "Stockist",
    "slug": "californias-finest-sukhumvit-soi-24-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "1F Zone B, 49 Sahai Place, Sukhumvit Soi 24, Khlong Tan, Khlong Toei, Bangkok 10110, Thailand",
    "phone": "080 930 0673",
    "website": "",
    "hours24": true,
    "lat": 13.7259874529572,
    "lng": 100.567662463829
  },
  {
    "id": 11,
    "name": "California's Finest Soi 30",
    "type": "Stockist",
    "slug": "californias-finest-sukhumvit-soi-30-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "760/3 Sukhumvit Rd, Khlong Tan, Khlong Toei, Bangkok 10110, Thailand",
    "phone": "064 996 2888",
    "website": "",
    "hours24": true,
    "lat": 13.7268262547923,
    "lng": 100.574525124799
  },
  {
    "id": 12,
    "name": "California's Finest Soi 39",
    "type": "Stockist",
    "slug": "californias-finest-sukhumvit-soi-39-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "5, 9 Phrom Si 2 Alley, Khlong Tan Nuea, Watthana, Bangkok 10110, Thailand",
    "phone": "093 754 9511",
    "website": "",
    "hours24": false,
    "lat": 13.7367854182837,
    "lng": 100.57323754985
  },
  {
    "id": 13,
    "name": "California's Finest Tha Maharaj",
    "type": "Stockist",
    "slug": "californias-finest-tha-maharaj-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "Unit E1-06), 1, Tha Maharaj, 11 Trok Sathien, Phra Borom Maha Ratchawang, Bangkok 10200, Thailand",
    "phone": "064 995 9029",
    "website": "",
    "hours24": false,
    "lat": 13.7555302356946,
    "lng": 100.488842985693
  },
  {
    "id": 14,
    "name": "Candy Kush Thonglor",
    "type": "Stockist",
    "slug": "candy-kush-thonglor-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "89/1 Sukhumvit Soi 57, Khlong Tan Nuea, Bangkok 10110, Thailand",
    "phone": "062 885 2933",
    "website": "",
    "hours24": true,
    "lat": 13.7259417855581,
    "lng": 100.579907054787
  },
  {
    "id": 15,
    "name": "Cannabis Shop",
    "type": "Stockist",
    "slug": "cannabis-shop-city-center-hua-hin",
    "region": "Hua Hin",
    "country": "Thailand",
    "address": "59/79 1 Soi Hua Hin 1, Tambon Hua Hin, Amphoe Hua Hin, Chang Wat Prachuap Khiri Khan 77110, Thailand",
    "phone": "099 251 1788",
    "website": "",
    "hours24": false,
    "lat": 12.625637,
    "lng": 99.9509763
  },
  {
    "id": 16,
    "name": "Coffee Inc Nimman",
    "type": "Stockist",
    "slug": "coffee-inc-nimman-chiang-mai",
    "region": "Chiang Mai",
    "country": "Thailand",
    "address": "26/1 Nimmana Haeminda Road Lane 5, Tambon Su Thep, Chiang Mai, 50200, Thailand",
    "phone": "084 364 4719",
    "website": "",
    "hours24": false,
    "lat": 18.7984351937308,
    "lng": 98.9703932956117
  },
  {
    "id": 17,
    "name": "DUKE",
    "type": "Stockist",
    "slug": "duke-lopburi",
    "region": "Lopburi",
    "country": "Thailand",
    "address": "129 Thanon Naresuan, Khao Sam Yot, Lopburi 15000, Thailand",
    "phone": "096 351 5125",
    "website": "",
    "hours24": false,
    "lat": 14.8102823619933,
    "lng": 100.677417771164
  },
  {
    "id": 18,
    "name": "FIRE Dispensary",
    "type": "Stockist",
    "slug": "fire-dispensary-sukhumvit-soi-3-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "45/4 Soi Sukhumvit 3, Khlong Toei Nuea, Watthana, Bangkok 10110, Thailand",
    "phone": "093 756 2968",
    "website": "",
    "hours24": true,
    "lat": 13.7467115194572,
    "lng": 100.553537644365
  },
  {
    "id": 19,
    "name": "Hide Cafe Bar (Tani Road, Khaosan)",
    "type": "Stockist",
    "slug": "hide-cafe-bar-tani-road-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "11, 3 Tanee road, Kwaeng Taladyod, 1, 3 Thanon Tani, Talat Yot, Bangkok 10200, Thailand",
    "phone": "090 964 7573",
    "website": "",
    "hours24": true,
    "lat": 13.7608515124043,
    "lng": 100.498466125465
  },
  {
    "id": 20,
    "name": "High Thai Cannabis Bar",
    "type": "Stockist",
    "slug": "high-thai-sukhumvit-soi-33-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "Sukhumvit Rd, Khlong Tan, Khlong Toei, Bangkok 10110, Thailand",
    "phone": "064 656 3423",
    "website": "",
    "hours24": false,
    "lat": 13.7319446946848,
    "lng": 100.567850366891
  },
  {
    "id": 21,
    "name": "King Flowers Rangnam",
    "type": "Stockist",
    "slug": "king-flowers-victory-monument-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "101/7 Rang Nam Alley, Thanon Phaya Thai, Phaya Thai, Bangkok 10400, Thailand",
    "phone": "081 556 5091",
    "website": "",
    "hours24": false,
    "lat": 13.7615249058323,
    "lng": 100.540528275598
  },
  {
    "id": 22,
    "name": "Mary Jane Patpong",
    "type": "Stockist",
    "slug": "mary-jane-patpong-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "48 Soi Patpong 2, Suriwong, Bangkok 10500, Thailand",
    "phone": "065 709 3420",
    "website": "",
    "hours24": false,
    "lat": 13.7302140765773,
    "lng": 100.531676955743
  },
  {
    "id": 23,
    "name": "MedMen Sukhumvit Soi 11",
    "type": "Stockist",
    "slug": "medmen-sukhumvit-soi-11-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "33/1 Sukhumvit 11 Aly, Khlong Toei Nuea, Watthana, Bangkok 10110, Thailand",
    "phone": "082 492 9899",
    "website": "",
    "hours24": false,
    "lat": 13.7447717753622,
    "lng": 100.556653461228
  },
  {
    "id": 24,
    "name": "MINTZ Cannabis Bang Tao Phuket",
    "type": "Stockist",
    "slug": "mintz-cannabis-bangtao-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "55/2 Bandon, Choeng Thale, Thalang District, Phuket 83110, Thailand",
    "phone": "083 203 1882",
    "website": "",
    "hours24": false,
    "lat": 7.99400334873309,
    "lng": 98.3065604037215
  },
  {
    "id": 25,
    "name": "NNH Soi Nana Chinatown",
    "type": "Stockist",
    "slug": "never-not-high-chinatown-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "78 Soi Ram Maitri, Pom Prap, Pom Prap Sattru Phai, Bangkok 10100, Thailand",
    "phone": "097 063 9332",
    "website": "",
    "hours24": false,
    "lat": 13.7398890801299,
    "lng": 100.513960120955
  },
  {
    "id": 26,
    "name": "O Mart Liquor at Phangan",
    "type": "Stockist",
    "slug": "o-mart-liquor-koh-phangan",
    "region": "Surat Thani",
    "country": "Thailand",
    "address": "211 Tambon Ko Pha-ngan, Amphoe Ko Pha-ngan, Chang Wat Surat Thani 84280, Thailand",
    "phone": "077 945 275",
    "website": "",
    "hours24": false,
    "lat": 9.7108821,
    "lng": 99.9910915
  },
  {
    "id": 27,
    "name": "O’Mart liquor",
    "type": "Stockist",
    "slug": "o-mart-liquor-bo-put-koh-samui",
    "region": "Surat Thani",
    "country": "Thailand",
    "address": "23 Tambon Bo Put, Amphoe Ko Samui, Chang Wat Surat Thani 84320, Thailand",
    "phone": "065 623 2698",
    "website": "",
    "hours24": false,
    "lat": 9.5564049,
    "lng": 100.0528121
  },
  {
    "id": 28,
    "name": "Polaris+",
    "type": "Stockist",
    "slug": "polaris-phrom-phong-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "595/22, Ellsie Mall, Unit 14 . 10110, Bangkok, Thailand",
    "phone": "087 062 6438",
    "website": "",
    "hours24": false,
    "lat": 13.7322207,
    "lng": 100.5685084
  },
  {
    "id": 29,
    "name": "Polaris+ Growshop",
    "type": "Stockist",
    "slug": "polaris-growshop-patong-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "54 Phangmuang, Sai Kor Road, Patong, Kathu District, Phuket 83150, Thailand",
    "phone": "082 219 7812",
    "website": "",
    "hours24": false,
    "lat": 7.8835541,
    "lng": 98.2950779
  },
  {
    "id": 30,
    "name": "Puff Puff Patong Phuket",
    "type": "Stockist",
    "slug": "puff-puff-patong-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "54/9 Bangla Rd, Pa Tong, Kathu District, Phuket 83150, Thailand",
    "phone": "081 893 4199",
    "website": "",
    "hours24": false,
    "lat": 7.89287801242221,
    "lng": 98.2965423440992
  },
  {
    "id": 31,
    "name": "Pufftopia Patong Phuket",
    "type": "Stockist",
    "slug": "pufftopia-patong-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "8 Thanon Sawatdirak, Patong, Phuket, 83150, Thailand",
    "phone": "096 364 9149",
    "website": "",
    "hours24": true,
    "lat": 7.89735800832789,
    "lng": 98.2966089597078
  },
  {
    "id": 32,
    "name": "S&P Snus Cafe Lamai Koh Samui",
    "type": "Stockist",
    "slug": "sp-snus-cafe-lamai-koh-samui",
    "region": "Ko Samui",
    "country": "Thailand",
    "address": "147/3 . Maret, Ko Samui District, Surat Thani 84310",
    "phone": "091 758 5025",
    "website": "",
    "hours24": false,
    "lat": 9.47352305620888,
    "lng": 100.044184599402
  },
  {
    "id": 33,
    "name": "Siam Green Cannabis Chinatown",
    "type": "Stockist",
    "slug": "siam-green-cannabis-chinatown-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "325 Maha Chai Rd, Samran Rat, Phra Nakhon, Bangkok 10200, Thailand",
    "phone": "098 127 3004",
    "website": "",
    "hours24": false,
    "lat": 13.7528877399167,
    "lng": 100.504792659707
  },
  {
    "id": 34,
    "name": "Siam Green Cannabis Koh Samui",
    "type": "Stockist",
    "slug": "siam-green-cannabis-koh-samui",
    "region": "Ko Samui",
    "country": "Thailand",
    "address": "200, Chaweng Beach Rd, Bo Put, Ko Samui District, Surat Thani 84320, Thailand",
    "phone": "092 484 2330",
    "website": "",
    "hours24": false,
    "lat": 9.53050916150447,
    "lng": 100.0612945
  },
  {
    "id": 35,
    "name": "Siam Green Cannabis Nana",
    "type": "Stockist",
    "slug": "siam-green-cannabis-nana-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "210 Sukhumvit Rd, Khlong Toei, Bangkok 10110, Thailand",
    "phone": "093 323 6505",
    "website": "",
    "hours24": false,
    "lat": 13.738622882461,
    "lng": 100.557865872323
  },
  {
    "id": 36,
    "name": "Siam Green Cannabis Phrom Phong",
    "type": "Stockist",
    "slug": "siam-green-cannabis-phrom-phong-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "663 Sukhumvit Rd, Khlong Tan Nuea, Bangkok 10110, Thailand",
    "phone": "096 893 0545",
    "website": "",
    "hours24": false,
    "lat": 13.7304028597678,
    "lng": 100.57014692335
  },
  {
    "id": 37,
    "name": "Siam Green Cannabis Silom",
    "type": "Stockist",
    "slug": "siam-green-cannabis-silom-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "18 Si Lom Rd, Si Lom, Bangkok 10500, Thailand",
    "phone": "096 403 4198",
    "website": "",
    "hours24": false,
    "lat": 13.7290884709166,
    "lng": 100.535088725465
  },
  {
    "id": 38,
    "name": "Smoke Two Joints Bangsaen",
    "type": "Stockist",
    "slug": "smoke-two-joints-bangsaen",
    "region": "Bangsaen",
    "country": "Thailand",
    "address": "No. 215 Long Had Bangsaen Rd, Tambon Saen Suk, Mueang Chon Buri 20130, Thailand",
    "phone": "061 157 5658",
    "website": "",
    "hours24": false,
    "lat": 13.2850636049272,
    "lng": 100.918395456922
  },
  {
    "id": 39,
    "name": "Supermao",
    "type": "Stockist",
    "slug": "supermao-pattaya",
    "region": "Pattaya",
    "country": "Thailand",
    "address": "858/1 Moo 12, Nong Prue Sub-District,Bang Lamung District",
    "phone": "+66949352966",
    "website": "",
    "hours24": false,
    "lat": 12.9014405,
    "lng": 100.8699897
  },
  {
    "id": 40,
    "name": "Sweet & High Clock Tower Chiang Rai",
    "type": "Stockist",
    "slug": "sweet-and-high-clock-tower-chiang-rai",
    "region": "Chiang Rai",
    "country": "Thailand",
    "address": "531/4 Thanon Baanpa Pragarn Road, Chiang Rai, 57000, Thailand",
    "phone": "080 515 8888",
    "website": "",
    "hours24": false,
    "lat": 19.9064910347412,
    "lng": 99.8319767294466
  },
  {
    "id": 41,
    "name": "Sweet & High Dispensary Chiang Rai",
    "type": "Stockist",
    "slug": "sweet-and-high-chiang-rai",
    "region": "Chiang Rai",
    "country": "Thailand",
    "address": "880/3 Phaholyothin Rd, Tambon Wiang, Chang Wat, Chiang Rai 57000, Thailand",
    "phone": "080 515 8888",
    "website": "",
    "hours24": false,
    "lat": 19.9042111793174,
    "lng": 99.8331139860207
  },
  {
    "id": 42,
    "name": "The Quads Cannabis",
    "type": "Stockist",
    "slug": "the-quads-cannabis-bang-lamung-district",
    "region": "Bang Lamung District",
    "country": "Thailand",
    "address": "849 M 12 Thappraya Rd,Pattaya City,",
    "phone": "+66963619388",
    "website": "",
    "hours24": false,
    "lat": 12.9020696,
    "lng": 100.8692073
  },
  {
    "id": 43,
    "name": "Tint Toker",
    "type": "Stockist",
    "slug": "tint-toker-thonglor-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "762/9-11, Soi Sukhumvit 32, Sukhumvit Road Klongton Khet, Khet Khlong Toei, Krung Thep Maha Nakhon 10110, Thailand",
    "phone": "099 816 7772",
    "website": "",
    "hours24": false,
    "lat": 13.7264828,
    "lng": 100.5750188
  },
  {
    "id": 44,
    "name": "Wine Gallery",
    "type": "Stockist",
    "slug": "wine-gallery-koh-chang",
    "region": "Ko Chang",
    "country": "Thailand",
    "address": "50/18 Moo 4, Tambon Ko Chang, Ko Chang District, Trat 23170",
    "phone": "081 668 7035",
    "website": "",
    "hours24": false,
    "lat": 12.0370417208544,
    "lng": 102.293389202429
  },
  {
    "id": 45,
    "name": "101 Socialhaus Roi Et",
    "type": "Retailer",
    "slug": "101-socialhaus-roi-et",
    "region": "Roi Et",
    "country": "Thailand",
    "address": "486 Tambon Nuea Mueang, Amphoe Mueang Roi Et, Roi Et, 45000, Thailand",
    "phone": "095 978 9687",
    "website": "",
    "hours24": false,
    "lat": 16.067926069031,
    "lng": 103.673620456434
  },
  {
    "id": 46,
    "name": "28 Green Land",
    "type": "Retailer",
    "slug": "28-green-land-cha-am",
    "region": "Cha-am",
    "country": "Thailand",
    "address": "246/3 ถ.ร่วมจิตร ต.ชะอำ",
    "phone": "+66851933232",
    "website": "",
    "hours24": false,
    "lat": 12.7998526,
    "lng": 99.98553140000001
  },
  {
    "id": 47,
    "name": "Aura Snus Shop",
    "type": "Retailer",
    "slug": "aura-snus-shop-bang-tao-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "49, 14, Tambon Choeng Thale, Amphoe Thalang, Chang Wat Phuket 83110, Thailand",
    "phone": "",
    "website": "",
    "hours24": false,
    "lat": 7.99313,
    "lng": 98.3052467999999
  },
  {
    "id": 48,
    "name": "Aura Snus Shop",
    "type": "Retailer",
    "slug": "aura-snus-shop-chalong-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "14, 27, Tambon Chalong, Mueng, Chang Wat Phuket 83130, Thailand",
    "phone": "084 324 6043",
    "website": "",
    "hours24": false,
    "lat": 7.8500746,
    "lng": 98.3515825
  },
  {
    "id": 49,
    "name": "Aura Snus Shop",
    "type": "Retailer",
    "slug": "aura-snus-shop-rawai-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "48, 19, Tambon Rawai, Mueang, Chang Wat Phuket 83130, Thailand",
    "phone": "",
    "website": "",
    "hours24": false,
    "lat": 7.7776252,
    "lng": 98.3284283
  },
  {
    "id": 50,
    "name": "Beyond Cannabis",
    "type": "Retailer",
    "slug": "beyond-cannabis-mae-haad-koh-tao",
    "region": "Koh Tao",
    "country": "Thailand",
    "address": "9, 302, Koh Tao, Koh Phangan, Chang Wat Surat Thani 84360, Thailand",
    "phone": "099 420 4145",
    "website": "",
    "hours24": true,
    "lat": 10.0938596,
    "lng": 99.8279998
  },
  {
    "id": 51,
    "name": "Choo Choo Hemp",
    "type": "Retailer",
    "slug": "choo-choo-hemp-phrom-phong-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "108/4-5 Sukhumvit 49 Watthana district, sub district, Bangkok 10110, Thailand",
    "phone": "081 644 0515",
    "website": "",
    "hours24": false,
    "lat": 13.7345244,
    "lng": 100.5771314
  },
  {
    "id": 52,
    "name": "Choo Choo Hemp Koh Phangan",
    "type": "Retailer",
    "slug": "choo-choo-hemp-koh-phangan",
    "region": "Ko Pha Ngan",
    "country": "Thailand",
    "address": "161/44, Ko Pha-ngan District, Surat Thani 84820, Thailand",
    "phone": "061 656 9614",
    "website": "",
    "hours24": false,
    "lat": 9.7148515877973,
    "lng": 99.98841706687
  },
  {
    "id": 53,
    "name": "Good Life Dacha",
    "type": "Retailer",
    "slug": "good-life-dacha-pai",
    "region": "Pai",
    "country": "Thailand",
    "address": "298, ตำบล เวียงใต้ อำเภอปาย แม่ฮ่องสอน",
    "phone": "+66654204111",
    "website": "",
    "hours24": false,
    "lat": 19.3522509,
    "lng": 98.4380676
  },
  {
    "id": 54,
    "name": "Maxmarket",
    "type": "Retailer",
    "slug": "maxmarket-city-center-hua-hin",
    "region": "Hua Hin",
    "country": "Thailand",
    "address": "34, 100 Soi Mu Ban Dusit Land & House, Tambon Hua Hin, Amphoe Hua Hin, Chang Wat Prachuap Khiri Khan 77110, Thailand",
    "phone": "085 437 8546",
    "website": "",
    "hours24": false,
    "lat": 12.5531089,
    "lng": 99.9578571999999
  },
  {
    "id": 55,
    "name": "Nok Mini Mart",
    "type": "Retailer",
    "slug": "nok-mini-mart-krabi",
    "region": "Krabi",
    "country": "Thailand",
    "address": "164/5 Moo 2,Aonang",
    "phone": "+66624236567",
    "website": "",
    "hours24": false,
    "lat": 8.0336224,
    "lng": 98.8197254
  },
  {
    "id": 56,
    "name": "NORDIC POUCH - Snus Shop On Nut",
    "type": "Retailer",
    "slug": "nordic-pouch-snus-shop-on-nut-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "486 On Nut Rd, On Nut, Khet Suan Luang, Krung Thep Maha Nakhon 10250, Bangkok, Thailand",
    "phone": "080 967 7394",
    "website": "",
    "hours24": false,
    "lat": 13.7113951,
    "lng": 100.6080842
  },
  {
    "id": 57,
    "name": "Shogun Smoke Shop",
    "type": "Retailer",
    "slug": "shogun-smoke-shop-old-town-chiang-mai",
    "region": "Chiang Mai",
    "country": "Thailand",
    "address": "34/4 Rajwithi Road, Chiang Mai 50200, Thailand",
    "phone": "088 261 6986",
    "website": "",
    "hours24": false,
    "lat": 18.7906116,
    "lng": 98.9910245
  },
  {
    "id": 58,
    "name": "Snoop Weed",
    "type": "Retailer",
    "slug": "snoop-weed-bo-put-koh-samui",
    "region": "Ko Samui",
    "country": "Thailand",
    "address": "165/33, Moo 1, Soi Sunday, Surat Thani 84320, Thailand",
    "phone": "+66949902359",
    "website": "",
    "hours24": false,
    "lat": 9.5547094,
    "lng": 100.0359177
  },
  {
    "id": 59,
    "name": "Snus Point Bangtao",
    "type": "Retailer",
    "slug": "snus-point-bangtao-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "Cherngtalay, 116 Srisoonthorn rd, Tambon Choeng Thale, Amphoe Thalang, Chang Wat Phuket 83110, Thailand",
    "phone": "064 506 5802",
    "website": "",
    "hours24": false,
    "lat": 7.9762675,
    "lng": 98.2850869
  },
  {
    "id": 60,
    "name": "Snus Point Kamala",
    "type": "Retailer",
    "slug": "snus-point-kamala-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "33 59 Kamala 1, Tambon Kamala, Amphoe Kathu, Chang Wat Phuket 83150, Thailand",
    "phone": "083 527 3786",
    "website": "",
    "hours24": false,
    "lat": 7.94666999999999,
    "lng": 98.2804555
  },
  {
    "id": 61,
    "name": "Snus Point Kathu",
    "type": "Retailer",
    "slug": "snus-point-kathu-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "5, Subdistrict, 314 Moo 4 Tambon Wichit, Amphoe Mueang Phuket, Chang Wat Phuket 83000, Thailand",
    "phone": "084 216 7500",
    "website": "",
    "hours24": false,
    "lat": 7.88932779999999,
    "lng": 98.363481
  },
  {
    "id": 62,
    "name": "Snus Point Rawai",
    "type": "Retailer",
    "slug": "snus-point-rawai-phuket",
    "region": "Phuket",
    "country": "Thailand",
    "address": "5, 48 Wiset Rd, Tambon Rawai, Mueang, Chang Wat Phuket 83130, Thailand",
    "phone": "080 981 7568",
    "website": "",
    "hours24": false,
    "lat": 7.8132522,
    "lng": 98.3388215
  },
  {
    "id": 63,
    "name": "Solz Container & Cafe",
    "type": "Retailer",
    "slug": "solz-container-cafe-city-center-hua-hin",
    "region": "Hua Hin",
    "country": "Thailand",
    "address": "38, 248, Tambon Hua Hin, Amphoe Hua Hin, Chang Wat Prachuap Khiri Khan 77110, Thailand",
    "phone": "082 152 3475",
    "website": "",
    "hours24": false,
    "lat": 12.5564103,
    "lng": 99.9382433
  },
  {
    "id": 64,
    "name": "Thai Cannabis Dispensary",
    "type": "Retailer",
    "slug": "thai-cannabis-dispensary-khaosan-road-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "Bangkok, 76 10200",
    "phone": "66982677792",
    "website": "",
    "hours24": false,
    "lat": 13.7601132,
    "lng": 100.4969341
  },
  {
    "id": 65,
    "name": "The Upper Sip x Bangkok Snus",
    "type": "Retailer",
    "slug": "the-upper-sip-nong-bon-bangkok",
    "region": "Bangkok",
    "country": "Thailand",
    "address": "68, 18 2, Khwaeng Nong Bon, Khet Prawet, Krung Thep Maha Nakhon 10250, Bangkok, Thailand",
    "phone": "082 171 6728",
    "website": "",
    "hours24": false,
    "lat": 13.6780314,
    "lng": 100.6432962
  }
];
